import $ from 'jquery';
import 'slick-carousel';

export default class Slider {
  constructor() {
    this.resizeTimer = null;
    this.init();
  }

  init() {
    this.sliderSetting();
    $(window).on('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.sliderSetting(), 150);
    });
  }

  sliderSetting() {
    const $checkFlowSlider = $('.js-check-flow-slider');
    const $clinicYoutubeSlider = $('.js-clinic-youtube-slider');
    const hasClinicYoutubeDesktopSlider = Number($clinicYoutubeSlider.data('video-count')) > 3;

    if (window.innerWidth < 768) {
      $checkFlowSlider.not('.slick-initialized').slick({
        slidesToShow: 1,
        infinite: false,
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        prevArrow: '<button type="button" class="p-check-flow__arrow p-check-flow__arrow--prev" aria-label="前のステップ"></button>',
        nextArrow: '<button type="button" class="p-check-flow__arrow p-check-flow__arrow--next" aria-label="次のステップ"></button>',
      });
      this.setCheckFlowMinHeight($checkFlowSlider);

      const isYoutubeSliderInitialized = $clinicYoutubeSlider.hasClass('slick-initialized');
      const isYoutubeMobileConfig = isYoutubeSliderInitialized
        && $clinicYoutubeSlider.slick('getSlick').options.slidesToShow === 1;

      if (!isYoutubeMobileConfig) {
        if (isYoutubeSliderInitialized) $clinicYoutubeSlider.slick('unslick');
        $clinicYoutubeSlider.slick({
          slidesToShow: 1,
          rows: 0,
          infinite: true,
          centerMode: true,
          centerPadding: '0',
          variableWidth: true,
          initialSlide: 0,
          dots: true,
          arrows: true,
          adaptiveHeight: false,
          prevArrow: '<button type="button" class="p-clinic-youtube__arrow p-clinic-youtube__arrow--prev" aria-label="前の動画"></button>',
          nextArrow: '<button type="button" class="p-clinic-youtube__arrow p-clinic-youtube__arrow--next" aria-label="次の動画"></button>',
        });
      }
    } else if ($checkFlowSlider.hasClass('slick-initialized')) {
      $checkFlowSlider.slick('unslick');
      $checkFlowSlider.css('min-height', '');
      $checkFlowSlider.find('.p-check-flow__item').css('min-height', '');
    }

    if (window.innerWidth >= 768) {
      const isYoutubeSliderInitialized = $clinicYoutubeSlider.hasClass('slick-initialized');
      const isYoutubeDesktopConfig = isYoutubeSliderInitialized
        && $clinicYoutubeSlider.slick('getSlick').options.slidesToShow === 3;

      if (hasClinicYoutubeDesktopSlider && !isYoutubeDesktopConfig) {
        if (isYoutubeSliderInitialized) $clinicYoutubeSlider.slick('unslick');
        $clinicYoutubeSlider.slick({
          slidesToShow: 3,
          rows: 0,
          infinite: true,
          centerMode: true,
          centerPadding: '0',
          variableWidth: true,
          dots: true,
          arrows: true,
          adaptiveHeight: false,
          prevArrow: '<button type="button" class="p-clinic-youtube__arrow p-clinic-youtube__arrow--prev" aria-label="前の動画"></button>',
          nextArrow: '<button type="button" class="p-clinic-youtube__arrow p-clinic-youtube__arrow--next" aria-label="次の動画"></button>',
        });
      } else if (!hasClinicYoutubeDesktopSlider && $clinicYoutubeSlider.hasClass('slick-initialized')) {
        $clinicYoutubeSlider.slick('unslick');
      }
    }

    // .js-clinic_slider の設定
    $('.js-clinic_slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      arrows: true,
      dots: true,
      speed: 1000,
      autoplay: false,
      pauseOnHover: false,
      variableWidth: false,
      prevArrow: '<div class="slide-arrow prev-arrow"></div>',
      nextArrow: '<div class="slide-arrow next-arrow"></div>',
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }]
    });

    // .js-banner__slider の設定
    $('.js-banner__slider').not('.slick-initialized').slick({
      slidesToShow: 1,
      infinite: true,
      dots: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 800,
      pauseOnHover: false,
      prevArrow: '<div class="slide-arrow prev-arrow"></div>',
      nextArrow: '<div class="slide-arrow next-arrow"></div>',
    });

    // 同期スライダー：メインとサムネイル
   $('.js-box_main_slider').not('.slick-initialized').slick({
      slidesToShow: 1,
      fade: true,
      variableWidth: false,
      autoplay: false,
      arrows: false,
      asNavFor: '.js-thumbnail_slider',
    });

    // スライドの数を数える
    const slideCount = $('.js-thumbnail_slider > div').length;

    $('.js-thumbnail_slider').not('.slick-initialized').slick({
      slidesToShow: slideCount,
      asNavFor: '.js-box_main_slider',
      variableWidth: false,
      focusOnSelect: true,
    });

    // 大阪・名古屋・東京・福岡・札幌クリニック KV：サムネイルは固定表示のままメイン画像と同期
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $('.p-clinic-kv').each((_, clinicKv) => {
      const $clinicKv = $(clinicKv);
      const $mainSlider = $clinicKv.find('.js-clinic-kv-main-slider');
      const $thumbnails = $clinicKv.find('.js-clinic-kv-thumbnail-slider');

      if (!$mainSlider.length || !$thumbnails.length) return;

      const updateThumbnail = (currentSlide = 0) => {
        const slideIndex = Number(currentSlide);

        $thumbnails.find('.p-clinic-kv__thumbnail').each((_, thumbnail) => {
          const $thumbnail = $(thumbnail);
          const isActive = Number($thumbnail.data('slide-index')) === slideIndex;

          $thumbnail
            .toggleClass('is-active', isActive)
            .attr('aria-pressed', String(isActive));
        });
      };

      $mainSlider
        .off('.clinicKv')
        .on('init.clinicKv reInit.clinicKv', (event, slick, currentSlide) => {
          updateThumbnail(currentSlide);
        })
        .on('beforeChange.clinicKv', (event, slick, currentSlide, nextSlide) => {
          updateThumbnail(nextSlide);
        });

      $thumbnails
        .off('click.clinicKv', '.p-clinic-kv__thumbnail')
        .on('click.clinicKv', '.p-clinic-kv__thumbnail', (event) => {
          const slideIndex = Number($(event.currentTarget).data('slide-index'));

          if (!Number.isInteger(slideIndex)) return;

          updateThumbnail(slideIndex);
          $mainSlider.slick('slickGoTo', slideIndex, true);
        });

      $mainSlider.not('.slick-initialized').slick({
        slidesToShow: 1,
        rows: 0,
        infinite: true,
        fade: true,
        arrows: false,
        autoplay: !prefersReducedMotion,
        autoplaySpeed: 4000,
        speed: 300,
        pauseOnHover: true,
        pauseOnFocus: true,
      });

      updateThumbnail($mainSlider.slick('slickCurrentSlide'));
    });

    // 大阪クリニック限定プラン
    $('.js-osaka-plan-slider').not('.slick-initialized').slick({
      slidesToShow: 1,
      rows: 0,
      infinite: true,
      dots: true,
      arrows: true,
      adaptiveHeight: false,
      prevArrow: '<button type="button" class="p-clinic-osaka-plan__arrow p-clinic-osaka-plan__arrow--prev" aria-label="前のプラン"></button>',
      nextArrow: '<button type="button" class="p-clinic-osaka-plan__arrow p-clinic-osaka-plan__arrow--next" aria-label="次のプラン"></button>',
    });

    // 名古屋クリニック 治療症例
    $('.js-clinic-cases-slider').not('.slick-initialized').slick({
      slidesToShow: 2,
      rows: 0,
      infinite: true,
      dots: true,
      arrows: true,
      adaptiveHeight: false,
      prevArrow: '<button type="button" class="p-clinic-cases__arrow p-clinic-cases__arrow--prev" aria-label="前の治療症例"></button>',
      nextArrow: '<button type="button" class="p-clinic-cases__arrow p-clinic-cases__arrow--next" aria-label="次の治療症例"></button>',
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
          variableWidth: true,
        },
      }],
    });

    // 名古屋クリニック：全国クリニック一覧
    $('.js-clinic-directory-slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      rows: 0,
      infinite: true,
      centerMode: true,
      initialSlide: 2,
      variableWidth: true,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="p-clinic-directory__arrow p-clinic-directory__arrow--prev" aria-label="前のクリニック"></button>',
      nextArrow: '<button type="button" class="p-clinic-directory__arrow p-clinic-directory__arrow--next" aria-label="次のクリニック"></button>',
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          initialSlide: 0,
          infinite: true,
          variableWidth: false,
          arrows: true,
          dots: true,
          speed: 1000,
          autoplay: false,
          pauseOnHover: false,
        },
      }],
    });
  }

  setCheckFlowMinHeight($sliders) {
    $sliders.each((_, slider) => {
      const $slider = $(slider);
      const $slides = $slider.find('.p-check-flow__item').not('.slick-cloned');
      let maxHeight = 0;

      $slider.css('min-height', '');
      $slides.css('min-height', '');
      $slides.each((__, slide) => {
        maxHeight = Math.max(maxHeight, $(slide).outerHeight());
      });

      $slides.css('min-height', `${Math.ceil(maxHeight)}px`);
      $slider.css('min-height', `${Math.ceil(maxHeight)}px`);
    });
  }
}
